class BackInStockModal extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.setupModal()
    this.trapFocus()
  }

  setupModal () {
    if (!this.els.trigger.element) return

    this.els.trigger.element.addEventListener(
      'click',
      this.handleModalOpen.bind(this),
    )

    this.externalEls.trigger?.elements.forEach(trigger => {
      trigger.addEventListener('click', this.handleModalOpen.bind(this))
    })

    this.externalEls.close.elements.forEach(close => {
      close.addEventListener('click', this.handleModalClose.bind(this))
    })

    this.externalEls.window.elements.forEach(window => {
      window.addEventListener('keydown', e => this.handleKeyDown(e.key))
    })

    this.addEventListener('click', e => {
      if (e.target !== this) return
      this.setAttribute('aria-modal', 'false')
    })
  }

  handleKeyDown (key) {
    if (key === 'Escape' /* ESC */) {
      this.handleModalClose()
    }
  }

  handleModalOpen () {
    this.externalEls.modal.element.setAttribute(
      'data-product-id',
      this.els.trigger.element.dataset.productId,
    )
    this.externalEls.modal.element.setAttribute(
      'data-variant-id',
      this.els.trigger.element.dataset.variantId,
    )
    this.externalEls.modalForm.element.setAttribute(
      'data-back-end-flow',
      this.els.trigger.element.dataset.backEndFlow || '',
    )

    this.externalEls.modalForm.element.ariaHidden = 'false'

    this.externalEls.window.element.setAttribute('aria-hidden', 'false')
    this.externalEls.window.element.setAttribute('aria-expanded', 'true')
    this.externalEls.close.element.focus()
  }

  handleModalClose () {
    this.externalEls.window.element.setAttribute('aria-hidden', 'true')
    this.externalEls.window.element.setAttribute('aria-expanded', 'false')

    const closeBISModal = new CustomEvent('BISModalClosed')

    document.dispatchEvent(closeBISModal)
    window.removeEventListener('keydown', e => this.handleKeyDown(e.key))

    this.externalEls.window.elements.forEach(dialogWindow => {})

    const product = event.target.closest('.mod-Modal_Modal')
    if (!product) return
    this.els.trigger.elements.forEach(trigger => {
      if (trigger.dataset.productId === product.dataset.productId) {
        trigger.focus()
      }
    })
  }

  trapFocus () {
    const focusableEls = this.externalEls.window.element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
    )
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    this.externalEls.window.element.addEventListener('keydown', e => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }
}

customElements.define('back-in-stock-modal', BackInStockModal)
